"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderSliderInputs = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var helios_styles_1 = require("@carvana/helios-styles");
var styled_components_1 = __importDefault(require("styled-components"));
var SliderInput_1 = require("./SliderInput");
var FlexSpaceBetween = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  justify-content: space-between;\n"])));
var FlexColumn = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n"], ["\n  display: flex;\n  flex-direction: column;\n"])));
var LabelColumn = (0, styled_components_1.default)(FlexColumn)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  gap: 4px;\n"], ["\n  gap: 4px;\n"])));
var Label = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n"], ["\n  color: ", ";\n  ", "\n"])), helios_styles_1.text.strong, helios_styles_1.label.md);
var SubLabel = styled_components_1.default.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  color: ", ";\n  ", "\n"], ["\n  color: ", ";\n  ", "\n"])), helios_styles_1.text.default, helios_styles_1.label.xs);
var renderLabel = function (toRender, otherLabel) {
    if (toRender) {
        return (0, jsx_runtime_1.jsx)(Label, { children: toRender });
    }
    // This is to keep the inputs level with each other if a label is missing.
    return otherLabel && (0, jsx_runtime_1.jsx)(Label, { children: "\u00A0" });
};
function RenderSliderInputs(_a) {
    var _b, _c;
    var labels = _a.labels, disabled = _a.disabled, delay = _a.delay;
    if (!labels.length)
        return null;
    if (labels.length === 1) {
        var _d = labels[0], id = _d.id, inputLabel = _d.label, onChange = _d.onChange, value = _d.value, sublabel = _d.sublabel;
        return ((0, jsx_runtime_1.jsxs)(FlexSpaceBetween, { children: [(0, jsx_runtime_1.jsxs)(FlexColumn, { children: [inputLabel && (0, jsx_runtime_1.jsx)(Label, { children: inputLabel }), sublabel && (0, jsx_runtime_1.jsx)(SubLabel, { children: sublabel })] }), (0, jsx_runtime_1.jsx)(SliderInput_1.SliderInput, { id: id !== null && id !== void 0 ? id : 'slider-input-0', onChange: onChange, value: value, disabled: disabled, delay: delay })] }));
    }
    var leftLabel = labels[0], rightLabel = labels[1];
    return ((0, jsx_runtime_1.jsxs)(FlexSpaceBetween, { children: [(0, jsx_runtime_1.jsxs)(LabelColumn, { children: [renderLabel(leftLabel.label, rightLabel.label), (0, jsx_runtime_1.jsx)(SliderInput_1.SliderInput, __assign({}, leftLabel, { id: (_b = leftLabel.id) !== null && _b !== void 0 ? _b : 'slider-input-0', disabled: disabled, delay: delay }))] }), (0, jsx_runtime_1.jsxs)(LabelColumn, __assign({ style: { textAlign: 'right' } }, { children: [renderLabel(rightLabel.label, leftLabel.label), (0, jsx_runtime_1.jsx)(SliderInput_1.SliderInput, __assign({}, rightLabel, { id: (_c = rightLabel.id) !== null && _c !== void 0 ? _c : 'slider-input-1', disabled: disabled, delay: delay }))] }))] }));
}
exports.RenderSliderInputs = RenderSliderInputs;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
